<div class="loader-container" *ngIf="!hidden">
    <img *ngIf="size=='sm'" [src]="imagePath" class="loader-img-sm" />
    <img *ngIf="size=='md'" [src]="imagePath" class="loader-img-md" />
    <img *ngIf="size=='lg'" [src]="imagePath" class="loader-img-lg" />
</div>
<!--   <div class="holder" id="preloader">
    <div class="preloader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  </div> -->